import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Button } from './ui/button';
import { Label } from './ui/label';

export default function AdminPagesAuditDialog({
  open,
  onOpenChange,
  selectedPage,
  auditForm,
  setAuditForm,
  onSave,
  saving,
  statusOptions
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Audit de la page</DialogTitle>
        </DialogHeader>
        {selectedPage && (
          <div className="space-y-4 py-2">
            <div className="space-y-1 text-sm">
              <p className="font-medium" data-testid="audit-dialog-route">{selectedPage.route}</p>
              <p className="text-muted-foreground" data-testid="audit-dialog-name">{selectedPage.name}</p>
            </div>
            <div className="space-y-2">
              <Label>Statut d'audit</Label>
              <Select
                value={auditForm.audit_status}
                onValueChange={(value) => setAuditForm((prev) => ({ ...prev, audit_status: value }))}
              >
                <SelectTrigger data-testid="audit-status-select">
                  <SelectValue placeholder="Sélectionner" />
                </SelectTrigger>
                <SelectContent>
                  {statusOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Notes / nettoyage</Label>
              <textarea
                className="w-full min-h-[120px] rounded-md border border-border bg-background px-3 py-2 text-sm"
                value={auditForm.audit_notes}
                onChange={(e) => setAuditForm((prev) => ({ ...prev, audit_notes: e.target.value }))}
                placeholder="Ex: Page en double avec /schedule, fusionner avant suppression"
                data-testid="audit-notes-input"
              />
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="audit-cancel-button">
            Annuler
          </Button>
          <Button onClick={onSave} disabled={saving} data-testid="audit-save-button">
            {saving ? 'Sauvegarde...' : 'Sauvegarder'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}